import store from '@/store'
export default [
  {
    path: '/notification-templates',
    name: 'notification-template',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-template/index.vue')
  },
  {
    path: '/notification-templates/create',
    name: 'notification-template-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-template/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('notificationTemplate/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/notification-templates/:id',
    name: 'notification-template-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-template/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('notificationTemplate/dataBeforeCreate')
      await store.dispatch('notificationTemplate/find', to.params.id)
      next()
    }
  }
]
